import script from "./RatingList.vue?vue&type=script&lang=ts&setup=true&name=StandardList"
export * from "./RatingList.vue?vue&type=script&lang=ts&setup=true&name=StandardList"

const __exports__ = script;

export default __exports__